import { combineReducers } from 'redux'
import { UserState, userReducer } from './user/user.reducer'
import { CommonReducer, CommonState } from './common/common.reducer'

export interface ApiError {
  [key: string]: Response | Error | Record<string, unknown> | undefined
}

export interface LoginRootState {
  userStore: UserState
  commonStore: CommonState
}

export const loginRootReducer = combineReducers<LoginRootState>({
  userStore: userReducer,
  commonStore: CommonReducer
})
